import { render, staticRenderFns } from "./PagingFooter.vue?vue&type=template&id=2f14f371&"
import script from "./PagingFooter.vue?vue&type=script&lang=js&"
export * from "./PagingFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3192176617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f14f371')) {
      api.createRecord('2f14f371', component.options)
    } else {
      api.reload('2f14f371', component.options)
    }
    module.hot.accept("./PagingFooter.vue?vue&type=template&id=2f14f371&", function () {
      api.rerender('2f14f371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/PagingFooter.vue"
export default component.exports